import { withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e9f9224"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ap-icon-with-icon" }
const _hoisted_2 = ["value", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      class: _normalizeClass(["ap-input", _ctx.inputClass]),
      value: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      onInput: _cache[0] || (_cache[0] = ($event: any) => {
                _ctx.$emit('input', $event.target.value);
                _ctx.$emit('update:modelValue', $event.target.value);
            }),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event.target.value))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus', $event))),
      onKeypress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('keypress', $event))),
      onKeyup: [
        _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('keyup.down', $event)), ["down"])),
        _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.$emit('keyup.up', $event)), ["up"])),
        _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => {
                _ctx.$emit('keyup.enter', $event);
                _ctx.$emit('enter', $event.target.value);
            }, ["prevent"]), ["enter"]))
      ]
    }, null, 42, _hoisted_2),
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["ap-icon ap-input-icon", [_ctx.icon]]),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (!_ctx.disabled && _ctx.$emit('icon-click', $event, _ctx.modelValue)))
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}